import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import prettyMilliseconds from 'pretty-ms'
import styled from 'styled-components'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { Form, Input, Button, Tooltip, Margin } from '../../..'
import { colors } from '../../../../constants'
import { connect } from 'react-redux'
import { FileUtils } from '../../../../utils'
import { Tiptext } from '../../../Tooltip'

const QuestionMark = styled(FontAwesomeIcon)`
    cursor: pointer;
    font-size: 12px;
    opacity: 0.4;

    &:hover {
        opacity: 0.3;
    }
`

const { Label } = Form

class ChannelsForm extends PureComponent {
    static propTypes = {
        chains:PropTypes.arrayOf(
            PropTypes.shape({
                id: PropTypes.number,
                name: PropTypes.string,
            }),
        ).isRequired,
        errors: PropTypes.shape({
            name: PropTypes.string,
            slug: PropTypes.string,
            synced: PropTypes.string,
        }),
        innerRef: PropTypes.shape({}),
        values: PropTypes.shape({}),
        onChangeForm: PropTypes.shape({
            name: PropTypes.func,
            slug: PropTypes.func,
            synced: PropTypes.func,
        }),
        onClickSubmit: PropTypes.func,
        onOpenSettings: PropTypes.func,
        onOpenUploadMedia: PropTypes.func,
        isOpen: PropTypes.bool,
        enablePromo: PropTypes.bool,
        t: PropTypes.func.isRequired,
    }

    static defaultProps = {
        isOpen: false,
        errors: {
            name: null,
            slug: null,
            synced: null,
        },
        innerRef: null,
        values: {},
        onChangeForm: {
            name: () => null,
            slug: () => null,
            synced: () => null,
        },
        onClickSubmit: (e) => typeof e.stopPropagation === 'function' && e.stopPropagation(),
    }

    render() {
        const {
            chains,
            errors,
            innerRef,
            onChangeForm,
            onClickSubmit,
            onOpenSettings,
            onOpenUploadMedia,
            values,
            isOpen,
            t,
            enablePromo,
        } = this.props
        const { name: errorName } = errors
        const { name, chain_id, synced } = values
        const { name: onChangeName, synced: onChangeSynced } = onChangeForm
        const { storeContent } = this.props

        const channelId = storeContent.selected?.channels?.id

        const channelObject = storeContent.channels.filter((obj) => obj.id === channelId)
        const channelSize = channelObject[0]?.channel_size ? FileUtils.humanFileSize(channelObject[0]?.channel_size) : 0
        const mediaLength = prettyMilliseconds(channelObject[0]?.media_length || 0)
        const chain = chains.find(({ id }) => id === chain_id) || {}

        return (
            <div
                className="channel-settings"
                style={{
                    textAlign: 'left',
                    marginTop: isOpen && '10px',
                    marginBottom: isOpen && '10px',
                    paddingTop: '10px',
                    paddingBottom: '10px',
                    paddingLeft: '15px',
                    borderTop: `1px ${colors.bluelight} solid`,
                    borderBottom: `1px ${colors.bluelight} solid`,
                }}
            >
                <Label label={t('Channel Name')} error={errorName} noMargin>
                    <Input
                        ref={innerRef}
                        name="name"
                        type="text"
                        error={!!errorName}
                        onChange={onChangeName}
                        size="md"
                        value={name}
                        onClick={(e) => e.stopPropagation()}
                        borderColor={colors.bluedarkest}
                        style={{ padding: '9px' }}
                    />
                </Label>
                <div>
                    {t('Chain')}: {chain.name}
                </div>
                <div>
                    <Tooltip>
                        Size: {channelSize}
                        <Margin left inline size="xs">
                            <QuestionMark icon="question-circle" />
                        </Margin>
                        <Tiptext position="top">{t('channel-size-description')}</Tiptext>
                    </Tooltip>
                </div>
                <div>Length: {mediaLength}</div>
                <div
                    style={{
                        marginTop: '4px',
                        marginBottom: '8px',
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: '6px',
                    }}
                >
                    <span>{t('Syncing')}:</span>
                    <Input
                        type="check"
                        value={!!synced}
                        onChange={onChangeSynced}
                        borderColor={colors.bluedarkest}
                    />
                </div>
                <div
                    style={{
                        display: 'block',
                        textAlign: 'right',
                        marginTop: '10px',
                    }}
                >
                    <Button icon="save" iconSize="lg" onClick={onClickSubmit} theme="secondary" radius={5} size="xs" padding="6px">
                        {t('Save')}
                    </Button>
                    <Button icon="cog" iconSize="lg" onClick={onOpenSettings} theme="secondary" radius={5} size="xs" padding="6px">
                        {t('Settings')}
                    </Button>
                    {enablePromo ? (
                        <Button icon="cog" iconSize="lg" onClick={onOpenUploadMedia} theme="secondary" radius={5} size="xs" padding="5px">
                            {t('Promo')}
                        </Button>
                    ) : (
                        <></>
                    )}
                </div>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        chains: state.chains.chains,
        storeContent: state.content,
    }
}

// eslint-disable-next-line react/no-multi-comp
const ConnectedChannelsForm = connect(mapStateToProps)(React.forwardRef((props, ref) => <ChannelsForm innerRef={ref} {...props} />))

export default ConnectedChannelsForm
